import { actions } from "../slice.js";
import { thunkTypes } from "../thunk-types.js";
import { createAsyncThunk } from "@reduxjs/toolkit";
//#region src/redux/build/thunks/get-build.ts
var getBuild = createAsyncThunk(thunkTypes.GET_BUILD, async (_, { extra, dispatch }) => {
	dispatch(actions.updateBuild({ build: extra.build }));
	return extra.build;
});
//#endregion
export { getBuild };

//# sourceMappingURL=get-build.js.map